import { render, staticRenderFns } from "./ModalNotifi.vue?vue&type=template&id=4d349a56"
import script from "./ModalNotifi.vue?vue&type=script&lang=js"
export * from "./ModalNotifi.vue?vue&type=script&lang=js"
import style0 from "./ModalNotifi.vue?vue&type=style&index=0&id=4d349a56&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports